import type { CompanyBalanceEvidence } from './companyBalanceApi';

export interface CompanyBalanceRealization {
  complete: number;
  total: number;
  percent: number;
}

export function resolveOrderRealization(evidence: CompanyBalanceEvidence): CompanyBalanceRealization {
  if (evidence.orderedLineValue > 0) {
    return {
      complete: evidence.deliveredLineValue,
      total: evidence.orderedLineValue,
      percent: Math.min(100, Math.max(0, Math.round(evidence.deliveryPercent))),
    };
  }
  const candidates = [
    [evidence.deliveredCargoProductCount, evidence.productCount],
    [evidence.deliveredTransportCount, evidence.transportCount],
    [evidence.releasedWzCount, evidence.wzCount],
  ];
  const [complete, total] = candidates.find(([, candidateTotal]) => candidateTotal > 0) || [0, 0];

  return {
    complete,
    total,
    percent: total > 0 ? Math.min(100, Math.round((complete / total) * 100)) : 0,
  };
}
